import i18n from "../i18n";
import { detectUserLanguage } from "./languageDetection";
import logger from "./logger";

/**
 * Initializes the application language based on user location
 * This should be called once when the app starts
 */
export const initializeLanguage = async (): Promise<void> => {
  try {
    // Only attempt IP-based detection if user hasn't set a preference
    const savedLanguage = localStorage.getItem("language");
    if (!savedLanguage) {
      const detectedLanguage = await detectUserLanguage();

      // Change the language without saving to localStorage yet
      // This allows the user to still change it if they want
      await i18n.changeLanguage(detectedLanguage);
    }
  } catch (error) {
    logger.error("Failed to initialize language:", error);
    // Fallback is already handled in i18n config
  }
};
